const IS_INSTALL_PROMPT_SUPPORTED = 'onbeforeinstallprompt' in window;
export default IS_INSTALL_PROMPT_SUPPORTED;
